const useScrollBarWidth = () => {
  const div = document.createElement('div');
  const root = document.documentElement;

  div.style.overflowY = 'scroll';
  div.style.width = '50px';
  div.style.height = '50px';

  // must put it in the document, otherwise sizes will be 0
  document.body.append(div);
  const scrollWidth = div.offsetWidth - div.clientWidth;

  div.remove();

  root.style.setProperty('--scroll-bar-size', `${scrollWidth}px`);
};

export default useScrollBarWidth;
